let notDashboard = new Set(['todo', 'goal', 'reward'])
export default notDashboard